<template>
    <div>
        <v-btn 
            @click.native="showDialog=true"
            class="select-service-button"
            style="margin-left:0"
        > 
            <span v-if="selectedCustomer">
                {{selectedCustomer.name}} {{selectedCustomer.lastname}}
            </span>
            <span v-else>
                Selezionare...
            </span>
        </v-btn>
        <v-dialog
            v-model="showDialog"
            width="500"
        >
            <v-card>
                <v-card-title class="text-h5 grey lighten-2">
                    Seleziona cliente
                </v-card-title>
                <v-card-text>
                    <v-text-field
                        v-model="searchedText"
                        placeholder="Cerca..."
                    ></v-text-field>
                    <v-card 
                        class="customer-for-picker"
                        v-for="customer in filteredCustomers" :key="customer.id" 
                        @click="customerClicked(customer)"
                        style="background: #e0e0e0"
                    >
                        <v-card-text>
                            <div class="inline-block" style="max-width: calc(100% - 70px);">
                                {{customer.name}} {{customer.lastname}}
                            </div>
                        </v-card-text>
                    </v-card>
                    <div 
                        style="width:100%; text-align:center; font-style:italic;"
                        v-if="filteredCustomers.length==100"
                    >
                        <br>
                        Vengono mostrati solo i primi 100 risultati.
                        <br>
                    </div>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="primary"
                        text
                        @click="showDialog = false"
                    >
                        Annulla
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
const axios = require('axios').default;
export default {
  name: "SelectCustomer",
  props: ["value"],
  data() {
    return {
        showDialog: false,
        selectedValue: null,
        customers:[],
        maxElements: 100,
        searchedText: ""
    };
  },
  methods: {
    getCustomers(){
        let vm = this;
        axios({
            method: "GET",
            url: vm.$API_BASE_URL + "getCustomers.php",
            headers: {
                'Authentication-Token': window.localStorage.getItem("sogno_at")
            }
        })
        .then(function (response) {
            if (response.status == 200) {
                vm.customers = [];
                vm.customers = response.data.resources;
            } 
            else{
                alert("Si è verificato un errore durante il caricamento");
            }
        })
        .catch(function (error) {
            if(error.response.status==403||error.response.status==401){
                vm.$router.push({name: 'login'});
            }
            else{
                alert("Si è verificato un errore durante il caricamento");
                console.error(error)
            }
        });
    },
    customerClicked(service){
        let vm = this;
        vm.selectedValue = service.id;
        vm.showDialog = false;
        vm.$emit("input", vm.selectedValue);
    }
  },
  mounted() {
    let vm = this;
    vm.getCustomers();
  },
  computed:{
    selectedCustomer(){
        let vm = this;
        return vm.customers.find(customer=>customer.id == vm.selectedValue);
    },
    filteredCustomers(){
        let vm = this;
        if(vm.searchedText=='')
            return vm.customers.slice(0, vm.maxElements);
        return vm.customers.filter(function(el){
            return JSON.stringify(el).toUpperCase().includes(vm.searchedText.toUpperCase());
        }).slice(0, vm.maxElements);
    }
  },
  watch: {
    value: {
      handler: function (newValue) {
        let vm = this;
        vm.selectedValue=newValue;
      },
      immediate: true,
    }
  },
};
</script>

<style>
    .cardbutton .v-btn__content{
        display:block!important;
        text-align: left;
    }
    .cardbutton{
        padding: 30px 20px;
    }
    .v-card.customer-for-picker{
        margin-bottom:5px;
    }
    .select-service-button.v-btn {
        text-align: left;
        padding: 25px 10px 25px 10px;
        text-transform: none;
    }
</style>
